export function capitalizeString(str) {
    var string = str.toString();
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function filterAsOpen(item, hours) {
    let start, 
        end, 
        format = "HH:mm:ss",
        utcCurrentTime = moment().utc(),
        todaysHoursBlock = getTodaysHours(item),
        lobbyOpen = false,
        driveThruOpen = false;

    if (hours) {
        let dow = getDOW().toLowerCase(),
            todaysHours = hours[dow];
        if (todaysHours) {
            start = moment.tz(todaysHours.open, format, item.timeZone).utc(),
            end = moment.tz(todaysHours.close, format, item.timeZone).utc();

            return (
                utcCurrentTime.isBetween(start, end) ||
                utcCurrentTime.isSame(start) ||
                utcCurrentTime.isSame(end)
            );
        }
    }
    else if (todaysHoursBlock) {
        if (todaysHoursBlock.lobbyHours) {
            let todaysLobbyHours = todaysHoursBlock.lobbyHours;
            if (todaysLobbyHours && todaysLobbyHours.open && todaysLobbyHours.close) {
                start = moment.tz(todaysLobbyHours.open, format, item.timeZone).utc();
                end = moment.tz(todaysLobbyHours.close, format, item.timeZone).utc();

                lobbyOpen = (
                    utcCurrentTime.isBetween(start, end) ||
                    utcCurrentTime.isSame(start) ||
                    utcCurrentTime.isSame(end)
                );
            }
        }

        if (todaysHoursBlock.driveThruHours) {
            let todaysDriveThruHours = todaysHoursBlock.driveThruHours;
            if(todaysDriveThruHours && todaysDriveThruHours.open && todaysDriveThruHours.close) {
                start = moment.tz(todaysDriveThruHours.open, format, item.timeZone).utc();
                end = moment.tz(todaysDriveThruHours.close, format, item.timeZone).utc();

                driveThruOpen = (
                    utcCurrentTime.isBetween(start, end) ||
                    utcCurrentTime.isSame(start) ||
                    utcCurrentTime.isSame(end)
                );
            }
        }        
    }

    return lobbyOpen || driveThruOpen;
}

export function filterHours(list, hours) {
    let openSaturdays = hours && hours.indexOf("saturdays") > -1,
        open = hours && hours.indexOf("now") > -1;

    if (open) {
        list = list.filter(item => {
            return filterAsOpen(item);
        });
    }

    if (openSaturdays) {
        list = list.filter(item => {
            let itemLobbySaturdayHrs = item.lobbyHours["saturday"],
                itemDriveThruSaturdayHrs = item.driveThruHours["saturday"];
            
            return (itemLobbySaturdayHrs != undefined && itemLobbySaturdayHrs.open != undefined && itemLobbySaturdayHrs.close != undefined) ||
            (itemDriveThruSaturdayHrs != undefined && itemDriveThruSaturdayHrs.open != undefined && itemDriveThruSaturdayHrs.close != undefined);
        });
    }

    return list;
}

export function formatAddress(location) {
    let addressFormatted = "";
    if (location && location.address) {
        addressFormatted =
            (location.address.addressLine1 != null ? (location.address.addressLine1 + "<br />") : "") +
            (location.address.addressLine2 != null ? (location.address.addressLine2 + "<br />") : "") +
            (location.address.city != null ? location.address.city : "") +
            ((location.address.city != null ? ", " : "") + (location.address.state != null ? location.address.state : "")) +
            ((location.address.state != null ? " " : "") + (location.address.zip != null ? location.address.zip : ""));
    }
    
    return addressFormatted;
}

export function formatDirectionsLink(location, loc) {
    if (location && location.address) {
        if (location.address.addressLine2 != null) {
            return `https://www.google.com/maps/dir/?api=1&origin=${loc.lat},${loc.lng}&destination=${location.address.addressLine1},${location.address.addressLine2},${location.address.city},${location.address.state},${location.address.zip}&travelmode=driving`;
        }
        else {
            return `https://www.google.com/maps/dir/?api=1&origin=${loc.lat},${loc.lng}&destination=${location.address.addressLine1},${location.address.city},${location.address.state},${location.address.zip}&travelmode=driving`;
        }
    }
    else { 
        return null;
    }
}

export function formatEmailLink(advisor) {
    return advisor.emailAddress ? "mailto:" + advisor.emailAddress : null;
}

export function formatTelephoneHref(phoneNumber) {
    const telephoneFormatted = phoneNumber.replace(new RegExp("[^0-9]", 'g'), '');

    return "tel:" + telephoneFormatted;
}

export function formatPhoneNumber(phone) {
    var cleaned = ('' + phone).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
}

export function getDOW() {
    let utcCurrentTime = moment().utc(),
        activeTimeZone = moment.tz.guess(true),
        timeInActiveTimeZone = moment.tz(utcCurrentTime, activeTimeZone),
        dow = timeInActiveTimeZone.format("dddd");

    return dow;
}

export function getTodaysHours(item) {
    let dow = getDOW().toLowerCase(),
        itemLobbyHrs = item.lobbyHours[dow],
        itemDriveThruHours = item.driveThruHours[dow],
        payload = {
            dow: dow,
            lobbyHours: itemLobbyHrs,
            driveThruHours: itemDriveThruHours
        };
    return payload;
}
